import requests, { setToken } from "../../services/httpServices";

/**
 * Lives beside InfluencerServices, under components/admin, because that is the
 * copy the admin screens import. There is a second AdminServices under
 * services/ - a method added only to that one is invisible here, which is how
 * the school-status dropdown shipped broken for a day.
 *
 * Errors propagate so the screen can show the real reason (409 names the code
 * that already exists).
 */
const PromoCodeServices = {
  getPromoCodes: async () => {
    setToken(localStorage.getItem("token"));
    return await requests.get("/admin/promo-codes");
  },
  createPromoCode: async (owner, percent) => {
    setToken(localStorage.getItem("token"));
    return await requests.post("/admin/promo-codes", { owner, percent });
  },
};

export default PromoCodeServices;
